import React from 'react'
import { useContext } from 'react'
import DataFetch from '../Context/DataFetch'
import TeamsInfo from './headtohead/TeamsInfo'
import Language  from '../Context/Language'


export default function Information() {
    const  {funfacts} = useContext(DataFetch)
    const datalang = useContext(Language)
  return (
<div className="İnformationTeamsArea">
    <TeamsInfo/>
<div className="my-collapsible__content">
  <div className="informationTeams">
    {
        funfacts ? 
        JSON.parse(funfacts).map(function(item ,i) {
            return <div id={i} className='FunAreaContainer' key={i}>
           <div className='FunAreaSpan'></div>
            <div className='FunAreaText'>{item.statement}</div>
            
            </div>
          }
          )
        :
        <div className='DATANOTFOUNDDİV'>
   <div>{datalang[sessionStorage.getItem("lang")].Nodata}</div>
  </div>
    }
  </div>
</div>
</div>
  )
}
